import { HeaderActionButton } from "@/components/atom/button/headerAction/HeaderActionButton";
import { WorkText } from "@/components/atom/text/work/WorkText";
import { WorkTitle } from "@/components/atom/title/work/WorkTitle";
import { QuantityBox } from "@/components/molecule/quantityBox/QuantityBox";
import { PalletLogsForm } from "@/components/organism/form/PalletLogsForm";
import { COMMON_TEXT } from "@/constants/text";
import { useModal } from "@/context/ModalStackManager";
import { useWorkLotsFetch } from "@/fetch/page/work/useWorkLotsFetch";
import { usePerformanceHandler } from "@/hooks/handler/usePerformanceHandler";
import { useWorkDataStore } from "@/store/work.store";
import { Flex } from "@mantine/core";
import { ProductionPlansGet200ResponseRowsInnerWorksInner } from "@sizlcorp/sizl-api-document/dist/models";
import { IconSeparatorVertical } from "@tabler/icons-react";

const WorkCurrentLot = Object.assign(
  {},
  {
    ActionButton: HeaderActionButton,
    Title: WorkTitle,
    Text: WorkText,
  }
);

export const WorkCurrentLotInform = () => {
  const { openModal } = useModal();
  const { handlePalletSeparate } = usePerformanceHandler();
  const { workData } = useWorkDataStore((state) => ({
    workData: state.workData,
  }));
  const { data } = useWorkLotsFetch({
    workData: workData.work as ProductionPlansGet200ResponseRowsInnerWorksInner,
  });

  const lotsName = data?.data.name;

  const { work } = workData;

  const handlePalletLogsForm = () => {
    return openModal(
      <PalletLogsForm />,
      "",
      COMMON_TEXT.FORM.PALLET_LOGS_TITLE
    );
  };

  return (
    <>
      <Flex w={"100%"}>
        <Flex
          w={"100%"}
          direction={"row"}
          align={"center"}
          justify={"space-between"}
        >
          <WorkCurrentLot.Title c={"#FFFFFF"} order={5}>
            {COMMON_TEXT.TITLE.CURRENT_LOT_PROGRESS}(
            {COMMON_TEXT.TITLE.LOT_NUMBER} :{" "}
            {lotsName ? lotsName.split("#").pop() : "-"})
          </WorkCurrentLot.Title>
          <Flex gap={"xs"}>
            <WorkCurrentLot.ActionButton
              onClick={handlePalletLogsForm}
              color="grape"
            >
              {COMMON_TEXT.BUTTON.PALLET_LOGS}
            </WorkCurrentLot.ActionButton>
            <WorkCurrentLot.ActionButton
              disabled={work?.currentLotSummary?.totalQuantity === "0"}
              onClick={handlePalletSeparate}
              color={"grape.6"}
              rightIcon={<IconSeparatorVertical size={"1.5rem"} />}
            >
              {COMMON_TEXT.BUTTON.PALLET_SEPARATE}
            </WorkCurrentLot.ActionButton>
          </Flex>
        </Flex>
      </Flex>
      <Flex justify={"space-between"} gap={"xs"} w={"100%"}>
        {[
          {
            title: COMMON_TEXT.TITLE.PRODUCTION_QUANTITY,
            color: "violet.4",
            value: work?.currentLotSummary?.end,
          },
          {
            title: COMMON_TEXT.TITLE.TOTAL_QUANTITY,
            color: "teal.4",
            value: work?.currentLotSummary?.totalQuantity,
          },
          {
            title: COMMON_TEXT.TITLE.DEFECT_QUANTITY,
            color: "red.4",
            value: work?.currentLotSummary?.defectTotal,
          },
        ].map((data, index) => (
          <QuantityBox
            size="xl"
            key={index + data.title}
            color={data.color}
            value={data.value}
            title={data.title}
          />
        ))}
      </Flex>
    </>
  );
};
